<div class="container">
    <div class="one-comment" *ngFor="let item of getComments()">
        <tam-comment [comments]="comments" [comment]="item" [config]="config"></tam-comment>
    </div>
</div>